import React, { useCallback, useContext, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './header.css';
import { ModalContext } from '../../contexts/modal.context';
import { ThemeContext } from '../../contexts/theme.context';
import { useTranslation } from 'react-i18next';
import RemoveAccountForm from '../removeAccountForm/removeAccountForm';

export default function Menu({ className }: { className: string }) {
  const { t, i18n } = useTranslation();
  const { darkTheme, setDarkTheme } = useContext(ThemeContext);
  const { setModalContent } = useContext(ModalContext);
  const pathname = window.location.pathname;

  const handleAboutUs = () => {
    setModalContent(
      <div>
        <h3>{t("About us")}</h3>
        <p>TBA</p>
      </div>
    );
  };

  const handleAccountDeletion = useCallback(() => {
    setModalContent(
      <div>
        <h3>{t("Remove account form")}</h3>
        <RemoveAccountForm />
      </div>
    );
  }, [setModalContent, t]);

  const toggleTheme = () => {
    setDarkTheme(!darkTheme);
  };

  const toggleLanguage = () => {
    i18n.changeLanguage(i18n.language === 'pl' ? 'en' : 'pl');
  };

  useEffect(() => {
    switch (pathname) {
      case '/deletion':
        handleAccountDeletion();
        break;
    }
  }, [pathname, handleAccountDeletion]);

  return (
    <nav>
      <div className={className}>
        <span onClick={handleAboutUs}>{t("About us")}</span>
        <span>
          <Link to="/tos">{t("Terms of Service")}</Link>
        </span>
        <span>
          <Link to="/privacy">{t("Privacy Policy")}</Link>
        </span>
        <span>
          <Link to="/health_info">{t("Health Information")}</Link>
        </span>
        <span onClick={toggleTheme}>{darkTheme ? t("Light mode") : t("Dark mode")}</span>
        <span onClick={toggleLanguage}>{i18n.language === 'en' ? "Polski" : "English"}</span>
      </div>
    </nav>
  );
}
